import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=3b47b93a&scoped=true&"
import script from "./AddTable.vue?vue&type=script&lang=js&"
export * from "./AddTable.vue?vue&type=script&lang=js&"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=3b47b93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47b93a",
  null
  
)

component.options.__file = "AddTable.vue"
export default component.exports